export { default } from "./VehicleIcon";